module.exports = __webpack_public_path__ + "static/media/AdobeSign_Step1_Image11.2ca90e86.jpg";